export const _LOAD_MODEL_COMPANY_ = 'Load:Company';
export const _LOAD_MODEL_MESSAGE_ = 'Load:Message';
export const _LOAD_MODEL_SETTING_ = 'Load:Setting';

export const COMPANY = {
  city: '',
  cnpj: '',
  site: '',
  state: '',
  email: '',
  number: '',
  address: '',
  zipcode: '',
  district: '',
  whatsapp1: '',
  whatsapp2: '',
  instagram: '',
};

export const MESSAGES = {
  footer: '',
  slogan: '',
  receipt: '',
  warranty: '',
  approbation: '',
  sendMessage: '',
  sendMessageWhats: '',
};

export const SETTINGS = {
  logo: null,
  warranty: null,
  timeAlert: null,
};

export const OPTION = { id: null, slug: null, name: '' };

export const PERMISSION = {
  module_id: null,
  name: null,
  description: null,
  slug: null,
  active: true,
};
